import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/certificate.css';
import 'react-toastify/dist/ReactToastify.css';
import { FaDownload } from 'react-icons/fa'; //icons
import { FaSignOutAlt } from 'react-icons/fa';
import certificate from '../img/certificate.jpg'
import celibration from '../img/celibration.gif'

import Footer from './footer';
import Com_Logo from './company_icon';

const Certificate = () => {

  const navigate = useNavigate();
  const [showGif, setShowGif] = useState(() => {
    // Check localStorage if gif was already shown
    const alreadyShown = localStorage.getItem('gifShown');
    return !alreadyShown;
  });

  useEffect(() => {
    if (showGif) {
      const timer = setTimeout(() => {
        setShowGif(false);
        localStorage.setItem('gifShown', 'true'); // gif show thase 1 var ane local set thase check karse local ma hase atle 2 var gis show nay thay
      }, 5000); // show for 5 seconds

      return () => clearTimeout(timer);
    }
  }, [showGif]);


  // download img process
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = certificate;            // Image source
    link.download = 'certificate.jpg';  // File name when downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

    // logout
  const handleLogout = () => {
    // Clear all session data
    sessionStorage.clear();
    localStorage.clear();
  
    navigate('/');
  };


  return (
    <>

  <Com_Logo />
      <div className="certificate-container text-center">
      {showGif ? (
        <img src={celibration} alt="Loading animation" className="gif-animation" />
      ) : (
         
        //  main container
         <div className="card text-center mx-auto" style={{border:'solid 2px #eb7907'}}>
      <div className="card-header" id="header_certi" style={{background:'#eb7907'}}>
        CERTIFICATE
      </div>

      <div className="card-body">
        <img 
          src={certificate} 
          className="img-fluid img_certi" 
          alt="Certificate"  
        />
      </div>

    </div>
      )}
    </div>

{/* button */}
{/* button section */}
<div className="container mt-4" id="btn_main">
  <div className="row">
    <div className="col-6 text-start">
      <button
        className="btn btn-danger btn-lg"
        type="button"
        id="logout"
        onClick={handleLogout}
      >
        Logout
        <FaSignOutAlt size={20} id="logout" style={{ marginLeft: '5px' }} />
      </button>
    </div>
    <div className="col-6 text-end">
      <button
        type="button"
        className="btn btn-primary btn-lg"
        id="btn_certi"
        onClick={handleDownload}
      >
        Download
        <FaDownload className="fa-bounce" id="btn_doe_icon" size={20} style={{ marginLeft: '5px' }} />
      </button>
    </div>
  </div>
</div>


<Footer />
    </>
  );
};

export default Certificate;
